<template>
    <div class="container mt-3">
        <h2 class="text-start" v-if="$route.params.estatus == 1">En proceso</h2>
        <h2 class="text-start" v-else-if="$route.params.estatus == 2">En resolución</h2>
        <h2 class="text-start" v-else-if="$route.params.estatus == 3">Dictaminadas</h2>
        <div class="row mt-4">
            <div class="col-sm-12 col-md-6">
                <div class="input-group mb-3">
                    <input
                        id="busquedaNombre"
                        type="text"
                        class="form-control rounded-pill"
                        placeholder="Buscar por nombre, folio o tipo de operación"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        v-model="NameFilter"
                        v-on:focus="monto = ''"
                    />
                </div>
            </div>
            <div class="col-sm-12 col-md-3">
                <div class="dropdown">
                    <button
                        class="btn btn-primary rounded-pill dropdown-toggle"
                        type="button"
                        id="dropdownMontos"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        Buscar por monto
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMontos">
                        <li><button class="dropdown-item" @click="monto = ''">Todos</button></li>
                        <li><button class="dropdown-item" @click="monto = 'a'">Hasta $1,000,000</button></li>
                        <li><button class="dropdown-item" @click="monto = 'b'">$1,000,001 - $2,500,000</button></li>
                        <li><button class="dropdown-item" @click="monto = 'c'">Más de $2,500,000</button></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row" v-if="operacionesFiltradas.length">
            <div class="col-sm-12 col-md-12 col-lg-6" v-for="operacion in operacionesFiltradas"
                :key="operacion.operacionId"
            >
                <div class="px-1 my-2 tarjetaOperacion">
                    <div class="text-start d-flex align-items-center ms-3 me-3">
                        <div  v-if="operacion.resolucion=='APROBADA'" class="me-4" style="font-size: 4rem; color: #17AD61;">
                            <i class="bi bi-check-circle"></i>
                        </div>
                        <div v-else-if="operacion.resolucion =='RECHAZADA'"  class="me-4" style="font-size: 4rem; color: #FF7184;">
                            <i class="bi bi-x-circle"></i>
                        </div>
                        <div v-else-if="operacion.resolucion=='PENDIENTE'" class="me-4" style="font-size: 4rem; color: #568FFE;">
                            <i class="bi bi-dash-circle"></i>
                        </div>
                        <div v-else-if="operacion.resolucion=='NO DEFINIDO'" class="me-4" style="font-size: 4rem; color: transparent;">
                            <i class="bi bi-dash-circle"></i>
                        </div>

                        <div >
                        <p class="nombreCliente">No. Folio: {{ operacion.folio }}</p>
                        <div v-for="(nombre, index) in operacion.nombresClientes" :key="index">
                            <p class="nombreCliente">Cliente: {{ $filters.CapitalizeFilter(nombre) }}</p>
                        </div>
                        <p>Tipo de Operación: {{ $filters.StringFilter(operacion.tipoOperacion) }}</p>
                        <p>Descripción: {{ $filters.StringFilter(operacion.descripcionOperacion) }}</p>
                        <p>Monto de Operación: <b>{{ $filters.MoneyFilter(operacion.montoOperacion) }}</b></p>
                        <p>Monto Adjudicado: <b>{{ $filters.MoneyFilter(operacion.totalMontoAdjudicado) }}</b></p>
                        <button class="btn btn-primary col-md-5 rounded-pill mb-2" @click="irDetalleOperacion(operacion.operacionId)">
                            Bitácora
                        </button>
                        </div>
                    </div>
                </div> 
            </div>
        </div>
        <div class="mt-3" v-else>
            <div class="alert alert-warning alert-dismissible fade show" role="alert">
                <i class="bi bi-exclamation-circle">Sin registros</i>
                <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ListaOperaciones",
    
    components: {},
    
    data() {
        return {
            valor: 1,
            NameFilter: '',
            monto: '',
            pagina: 1,
            porPagina: 6,
            esFiltrado: false,
            paginas:[]
        };
    },

    props: {
        operaciones: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        operacionesFiltradas() {
            if (this.monto == 'a') {
                this.esFiltrado = true;
                this.$emit('ToParent', this.esFiltrado);
                return this.operaciones
                    .filter(op =>
                        op.montoOperacion <= 1000000 ||
                        op.totalMontoAdjudicado <= 1000000
                )
            }
            if (this.monto == 'b') {
                this.esFiltrado = true;
                this.$emit('ToParent', this.esFiltrado);
                return this.operaciones
                    .filter(op =>
                        (op.montoOperacion > 1000000 && op.montoOperacion <= 2500000) ||
                        (op.totalMontoAdjudicado > 1000000 && op.totalMontoAdjudicado <= 2500000)
                )
            }
            if (this.monto == 'c') {
                this.esFiltrado = true;
                this.$emit('ToParent', this.esFiltrado);
                return this.operaciones
                    .filter(op =>
                        op.montoOperacion > 2500000 ||
                        op.totalMontoAdjudicado > 2500000
                )
            }           
            if (!this.NameFilter) {               
                this.esFiltrado = false;                
                this.$emit('ToParent', this.esFiltrado);                      
                return this.operaciones
            }
            return this.operaciones
                .filter(op=> {if(op.folio != null)
                   { 
                    this.esFiltrado = true;
                    this.$emit('ToParent', this.esFiltrado);                    
                    return  op.nombresClientes[0].toLowerCase().includes(this.NameFilter.toLowerCase()) ||
                    op.folio.toLowerCase().includes(this.NameFilter.toLowerCase()) ||
                    op.tipoOperacion.toLowerCase().includes(this.NameFilter.toLowerCase())
                   }
                else
                   { 
                    this.esFiltrado = true;
                    this.$emit('ToParent', this.esFiltrado);                   
                    return op.nombresClientes[0].toLowerCase().includes(this.NameFilter.toLowerCase()) ||
                    op.tipoOperacion.toLowerCase().includes(this.NameFilter.toLowerCase())
                   }})
            }
    },
/*
    watch: {
        $route() {
            this.NameFilter = ''
        }
    },
*/
    methods: { 
        irDetalleOperacion(id) {
            this.$router.push({ name: 'DetalleOperacion', params: {id, estatus: this.$route.params.estatus}})
        },

        paginar(operaciones) {
            let pagina = this.pagina
            let porPagina = this.porPagina
            let registroInicio = (pagina * porPagina) - porPagina
            let registroFin = (pagina * porPagina)
        }
    }
})
</script>

<style scoped>
.tarjetaOperacion {
        border: solid 1px #ffa000;
        min-height: 250px;
        font-family: Montserrat;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: 0em;
        text-align: left;
        color: #43425d;
    }

    .contenidoTarjeta {
        margin-left: 15%;
        margin-right: 15%;
    }

    .nombreCliente {
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 22px;
    }

    h3 {
        font-family: Montserrat;
        font-style: normal;
        font-weight: bold;
        font-size: 35px;
        line-height: 43px;
        color: #43425d;
        font-weight: 700;
        letter-spacing: 0em;
        text-align: left;
    }

    p {
        margin: 10px 0px;
    }

    #busquedaNombre {
        z-index: 1;
        background-image:url('../../../../../../public/icons/search.svg');
        background-size: 20px 20px;
        background-repeat: no-repeat;
        background-position: 10px;
        text-indent: 25px;
        border: solid 1px #FFA000;
        height: 50px;
    }

    #dropdownMontos {
        width: 280px;
        height: 50px;
    }

    .bi-exclamation-circle {
        font-size: 25px;
    }
/*
    .btn-primary {
        width: 150px;
        height: 30px;
        padding: 10px;
    }*/
</style>
